/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import {
  FormGroup,
  TextArea,
  Button,
  DataTable,
  TableContainer,
  TableToolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableHeader,
  TableCell,
  TableToolbarContent,
  Tile,
  Loading, //RITM1535076
  ComposedModal, //RITM1535076
  ModalHeader, //RITM1535076
  ModalBody, //RITM1535076
  ModalFooter, //RITM1535076
  FileUploader, //RITM1535076
} from 'carbon-components-react';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Close16 from '@carbon/icons-react/lib/close/16';
import Add16 from '@carbon/icons-react/lib/add/16';
import Save16 from '@carbon/icons-react/lib/save/16';
import SimpleReactValidator from 'simple-react-validator';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import moment from 'moment';
import { NoRecordsPlaceholder } from '../../../../helpers/jsonschemaform/DataTableExtention';
import ModalDrillPerson from "./ModalDrillPerson"; //RITM1535076
import { showNotification } from "../../../../helpers/notification/BaseNotification"; //RITM1535076
import { getSuccess, getError, entitiesLabels, apioperation, STATUS, DateFormat } from "../../../../helpers/Constants"; //RITM1535076
import FileDownLoadButton from "../../../common/FileDownloadButton"; //RITM1535076
import { Download16, Export16 } from "@carbon/icons-react/lib/"; //RITM1535076
import { api } from "../../../../helpers/api/api"; //RITM1535076

export default class DrillPersonnel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drillReport: this.props.drillReport || {},
      modalPersonDetailVisible: false,
      selectedPerson: {
        id: null,
      },//RITM1535076
      idToEditPerson: null, //RITM1535076
      keyModalDrillPerson: `modalDrillPerson_${new Date().getTime()}`, //RITM1535076
      downloadTemplateLoading: false, //RITM1535076
      isImportTemplateModalOpen: false, //RITM1535076
    };
    this.handlePersonDetailVisibility = this.handlePersonDetailVisibility.bind(this);
    this.handleDeletePersonModal = this.handleDeletePersonModal.bind(this);
    this.onPersonDelete = this.onPersonDelete.bind(this);
    this.savePersonnel = this.savePersonnel.bind(this);

    this.validator = new SimpleReactValidator({
      validators: {
        emails: {
          // name the rule
          message: 'The :attribute must be a valid email address list semicolon separated',
          rule: (val, params, validator) =>
            validator.helpers.testRegex(
              val,
              // eslint-disable-next-line no-useless-escape
              /^(([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\s*;\s*|\s*$))+$/i
            ) && params.indexOf(val) === -1,
          required: true, // optional
        },
        time: {
          message: ':attribute must be a valid time',
          rule: (val, params, validator) =>
            validator.helpers.testRegex(val, /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]+$/) &&
            params.indexOf(val) === -1,
          required: true, // optional
        },
        datePicker: {
          message: 'The :attribute must be a valid date with mm/dd/yyyy format',
          rule: (val, params) => moment(val).isValid() && params.indexOf(val) === -1,
          required: true, // optional
        },
      },
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.drillReport !== this.props.drillReport) {
      this.setState({ drillReport: nextProps.drillReport });
    }
  }

  onPersonDelete() {
    this.setState((prevState) => {
      const drillReport = { ...prevState.drillReport };
      const selectedPerson = { ...prevState.selectedPerson };
      drillReport.people = prevState.drillReport.people.filter(
        (item) => selectedPerson.id !== item.id
      );
      return { drillReport };
    });
    this.handleDeletePersonModal(null);
  }

  savePersonnel() {
    if (this.validator.fieldValid('people')) {
      this.props.onSave(this.state.drillReport);
    } else {
      this.validator.showMessageFor('people');
      this.forceUpdate();
    }
  }

  handlePersonDetailVisibility(id) {
    const person = this.state.drillReport.people.find((i) => i.id === id);
    this.setState((oldState) => ({
      modalPersonDetailVisible: !oldState.modalPersonDetailVisible,
      selectedPerson: person || {},
      idToEditPerson: id, //RITM1535076
      keyModalDrillPerson: `modalDrillPerson_${new Date().getTime()}`, //RITM1535076
    }));
  }

  handleDeletePersonModal(id) {
    const person = this.state.drillReport.people.find((i) => i.id === id);
    this.setState((oldState) => ({
      modalPersonDeleteVisible: !oldState.modalPersonDeleteVisible,
      selectedPerson: person || {},
    }));
  }

  renderDeletePeopleModal = () =>
    this.state.modalPersonDeleteVisible && (
      <div className="bx--modal bx--modal-tall is-visible">
        <div className="bx--modal-container">
          <div className="bx--modal-header">
            {/* RITM1535076 */}
            <h3 className="bx--modal-header__heading">Delete Drill Participant</h3>
            <Button
              className="bx--modal-close"
              renderIcon={Close16}
              onClick={this.handleDeletePersonModal}
              iconDescription=""
            />
          </div>

          <div className="bx--modal-content">
            <div className="bx--row bx--modal-content-detail">
              <div className="bx--col-lg-12 bx--col-md-12">
                <h5 className="align-center">Press confirm to remove selected person</h5>
              </div>
            </div>
          </div>
          <div className="bx--modal-footer">
            <Button
              className="button--max-width"
              kind="secondary"
              onClick={this.handleDeletePersonModal}
            >
              Cancel
            </Button>
            <Button className="button--max-width" kind="primary" onClick={this.onPersonDelete}>
              Confirm
            </Button>
          </div>
        </div>
      </div>
    );

  //RITM1535076
  addPerson = () => {
    this.setState({
      modalPersonDetailVisible: true,
      idToEditPerson: null,
      keyModalDrillPerson: `modalDrillPerson_${new Date().getTime()}`,
    });
  };

  toggleModal = (open, property) => {
    this.setState({ [property]: open });
  };

  handleSaveModalPerson = (data) => {

    if (data == null) return;

    this.setState((prevState) => {
      const drillReport = { ...prevState.drillReport };
      const selectedPerson = { ...prevState.selectedPerson, ...data };
      const selectedPerson1 = { ...prevState.selectedPerson, ...data };
      console.log(selectedPerson1)
      if (!selectedPerson.id) {
        selectedPerson.id = uuid();
        selectedPerson.idDrillReport = prevState.drillReport.id;
        const notact = [selectedPerson];
        drillReport.people = notact.concat(prevState.drillReport.people);
        this.handlePersonDetailVisibility(null);
      } else {
        console.log()
        drillReport.people = prevState.drillReport.people
          .filter((item) => selectedPerson.id !== item.id)
          .concat(selectedPerson);
        this.handlePersonDetailVisibility(null);
      }
      return { drillReport };
    });
  }
  toggleModalUploadTemplate = (open) => {
    this.fileUploader.clearFiles();
    this.setState({
      isImportTemplateModalOpen: open,
      isImportHC: true,
      message: [],
      statusUpload: null,
      canUpload: false,
      isFileValid: true,
      validationErrorTitle: "",
      validationErrorSubTitle: "",
      __filename: null,
    });
  };

  clearFiles = () => {
    this.fileUploader.clearFiles();
    this.setState(() => ({
      canUpload: false,
      isFileValid: true,
      validationErrorTitle: "",
      validationErrorSubTitle: "",
    }));
  };

  divMessaggImportHC() {
    return (
      <div>
        {!this.state.isImportTemplate ? "" : <Loading />}

        {this.state.message[0] == "Success" ? (
          <div />
        ) : (
          <div>
            {this.state.message.map((x) => (
              <div className="bx--row">
                <div className="srv-validation-message"> {x}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  onFileUploadChange = (evt) => {
    this.setState(() => ({ statusUpload: "edit" }));
    if (evt.target.files[0] && evt.target.files[0].size >= 4194304) {
      const nome = evt.target.files[0].name;
      this.fileUploader.clearFiles();
      this.setState(() => ({
        canUpload: false,
        message: [],
        isFileValid: false,
        isImportTemplate: false,
        validationErrorTitle: `${nome} exceeds size limit`,
        validationErrorSubTitle: "4mb max file size. Please select a new file and try again",
      }));
    } else {
      this.setState(() => ({
        canUpload: true,
        isFileValid: true,
        validationErrorTitle: "",
        validationErrorSubTitle: "",
        message: [],
      }));
    }
  };

  uploadTemplate = (event) => {
    if (this.state.statusUpload != null) {
      this.setState({
        isImportfunction: true,
        isImportTemplate: true,
        message: [],
      });
      event.preventDefault();
      this.setState(() => ({
        canUpload: true,
        isFileValid: true,
        validationErrorTitle: "",
        validationErrorSubTitle: "",
        statusUpload: "uploading",
      }));
      const formData = new FormData();
      formData.append("FileUploaded", event.target.inputFile.files[0]);

      api.upload(`/drill/${this.state.drillReport.id}/drillPersonnel/template`, formData)
        .then((response) => {

          this.setState(() => ({
            canUpload: false,
            isFileValid: true,
            validationErrorTitle: "",
            validationErrorSubTitle: "",
            statusUpload: "complete",
            message: response.data,
            isImportTemplate: false,
            isImportfunction: false,
          }));

          if (response.data && response.data[0] == "Success") {
            this.getDrillPersonnel();
            showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.EMERGENCYDRILL_PERSONNELTEMPLATE, apioperation.UPLOAD));
            this.setState(() => ({
              isImportTemplateModalOpen: false,
            }));
          }
        })
        .catch((error) => {
          this.setState(() => ({
            canUpload: true,
            isFileValid: false,
            statusUpload: "edit",
            isImportTemplate: false,
            isImportfunction: false,
            importDanger: true,
          }));
          showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.EMERGENCYDRILL_PERSONNELTEMPLATE, apioperation.UPLOAD));
        });
    }
  };

  getDrillPersonnel = () => {
    api.get(`drill/drillPersonnel/`, this.state.drillReport.id)
      .then((response) => {
        this.setState({
          drillReport: { ...this.state.drillReport, people: response.data }
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.EMERGENCYDRILL_PERSONNELTEMPLATE, apioperation.GET));
      });
  };

  renderUploadModal = () => (
    <form onSubmit={this.uploadTemplate}>
      <ComposedModal className="light-modal" open={this.state.isImportTemplateModalOpen} danger="false" onClose={() => false}>
        <ModalHeader className="margin-modal" buttonOnClick={() => this.toggleModalUploadTemplate(false)}>
          <p>Import Drill Participants</p>
        </ModalHeader>
        <ModalBody className="margin-modal">
          <div className="bx--file-container">
            <FileUploader
              ref={(node) => (this.fileUploader = node)}
              accept={[".xlsx"]}
              buttonKind="primary"
              buttonLabel="Choose a file"
              filenameStatus={this.state.statusUpload}
              iconDescription="Choose"
              labelTitle="Upload"
              multiple={false}
              name="inputFile"
              onClick={this.clearFiles}
              onChange={this.onFileUploadChange}
            />
          </div>
          <div>
            {this.state.isImportHC ? this.divMessaggImportHC() : ""}
            {this.state.isImportfunction ? <Loading /> : ""}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button kind="secondary" onClick={() => this.toggleModalUploadTemplate(false)}>
            Cancel
          </Button>
          <Button kind="primary" type={this.state.statusUpload != null ? "submit" : "button"} onClick={this.state.statusUpload != null ? this.clearFiles : null} disabled={!this.state.statusUpload}>
            Upload
          </Button>
        </ModalFooter>
      </ComposedModal>
    </form>
  );
  //End

  render() {
    const validations = {
      people: this.validator.message(
        'people',
        this.state.drillReport.people?.length > 0 ? this.state.drillReport.people[0] : '', //RITM1535076
        'required'
      ),
    };

    //RITM1535076
    const headers = [
      {
        key: 'type',
        header: 'Type',
      },
      {
        key: 'badgeNumber',
        header: 'Badge Number',
      },
      {
        key: 'surname',
        header: 'Surname',
      },
      {
        key: 'name',
        header: 'Name',
      },
      {
        key: 'position',
        header: 'Job Position',
      },
      {
        key: 'company',
        header: 'Company',
      },
      {
        key: 'idEmployer',
        header: 'idEmployer',
        visible: "false",
      },
    ];

    const modalPersonProps = {

      persons: this.state.drillReport.people,
      key: this.state.keyModalDrillPerson,
      title: "Drill Participants",
      editModel: this.state.idToEditPerson ? this.state.drillReport.people.find((el) => el.id == this.state.idToEditPerson) : null,
      isOpenModal: this.state.modalPersonDetailVisible,
      isEditModal: this.state.idToEditPerson != null,
      mode: this.state.idToEditPerson != null ? 2 : 0,
      toggleModal: (open) => this.toggleModal(open, "modalPersonDetailVisible"),
      save: this.handleSaveModalPerson,
      appType: this.props.appType,
    };
    //End
    return (
      <div>
        {/* RITM1535076 */}
        {this.renderUploadModal()}
        {!this.state.downloadTemplateLoading ? '' : <Loading />}
        <Tile light>
          <DataTable
            useZebraStyles
            rows={this.state.drillReport.people || []}
            headers={headers}
            render={({ rows, getHeaderProps }) => (
              <TableContainer>
                <TableToolbar>
                  <TableToolbarContent className="table-toolbar-custom-content">
                    <div className="bx--col-lg-8 bx--col-md-10 table-toolbar-custon-content-info-start ">
                      <h6>List Of People With Active Function</h6>
                    </div>
                    <div className="bx--col-lg-4 bx--col-md-2 table-toolbar-custon-content-info-end ">
                      {/* RITM1535076 */}
                      <FileDownLoadButton
                        className="btn-notext"
                        onError={(error) => {
                          showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.EMERGENCYDRILL_PERSON, apioperation.DOWNLOAD));
                        }}
                        renderIcon={Download16}
                        title="Download Drill Participant"
                        apiUrl={`/drill/${this.state.drillReport.id}/template`}
                        fileName="DrillParticipantTemplate.xlsx"
                        onDownLoadStart={() => {
                          this.setState({
                            downloadTemplateLoading: true,
                          });
                        }}
                        onDownLoadEnd={() => {
                          this.setState({
                            downloadTemplateLoading: false,
                          });
                        }}
                      >

                      </FileDownLoadButton>
                      {!this.props.editingDisabled && !this.props.drillReport.drillPlan?.maskedValue ? ( //RITM0946012 - Anonimizzazione Modulo Emergency Drill
                        //RITM1535076 
                        <>
                          <Button
                            className="btn-notext"
                            renderIcon={Export16}
                            title="Import Drill Participant"
                            onClick={() => this.toggleModalUploadTemplate(true)}
                          />
                          <Button
                            onClick={this.addPerson} //RITM1535076
                            kind="primary"
                            renderIcon={Add16}
                            disabled={this.props.editingDisabled}
                            iconDescription=""
                          >
                            Add New Person
                          </Button>
                        </>
                        //End
                      ) : (
                        ''
                      )}
                    </div>
                    {/* End */}
                  </TableToolbarContent>
                </TableToolbar>
                {this.renderDeletePeopleModal()}
                <Table>
                  <TableHead>
                    <TableRow>
                      {/* RITM1535076 */}
                      <TableHeader>S. No</TableHeader>
                      {headers.map((header) => (
                        <TableHeader className={`${header.visible == "false" ? "hidden" : ""}`} {...getHeaderProps({ header })}>{header.header}</TableHeader> //RITM1535076
                      ))}
                      <TableHeader className="align-center">Actions</TableHeader>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {!rows || rows.length < 1 ? (
                      <NoRecordsPlaceholder labelText="No Records" colSpan={headers.length + 1} />
                    ) : (
                      rows.map((row, index) => ( //RITM1535076
                        <TableRow key={`row_${row.id}`}>
                          {/* RITM1535076 */}
                          <TableCell key={`sNo_${row.id}`}>{index + 1}</TableCell>
                          {/* RITM1535076 */}
                          {row.cells.map((cell) => {
                            const cellHeader = headers.find((x) => x.key === cell.info.header);
                            return (
                              <TableCell key={cell.id} className={cellHeader?.visible == "false" ? "hidden" : ""}>
                                {cell.info.header.includes('date')
                                  ? moment(cell.value).format('DD/MM/YYYY')
                                  : cell.info.header.includes('workSite')
                                    ? cell.value?.name || 'N/A'
                                    : cell.value}
                              </TableCell>
                            );
                          })}
                          {/* End */}
                          <TableCell key="action" className="tableActions align-center">
                            {(!this.props.editingDisabled && !this.props.drillReport.drillPlan?.maskedValue) ? ( // RITM0946012 - Anonimizzazione Modulo Emergency Drill
                              <div>
                                {/* RITM1535076 */}
                                {row.cells[6].value == null ? (
                                  <Button
                                    onClick={() => this.handlePersonDetailVisibility(row.id)}
                                    size="small"
                                    renderIcon={Edit16}
                                    iconDescription="Edit"
                                    kind="ghost"
                                    disabled={this.props.editingDisabled}
                                  />
                                ) : (
                                  ''
                                )}
                                {/* End */}
                                <Button
                                  onClick={() => this.handleDeletePersonModal(row.id)}
                                  size="small"
                                  renderIcon={Delete16}
                                  iconDescription="Delete"
                                  kind="ghost"
                                  disabled={this.props.editingDisabled}
                                />
                              </div>
                            ) : (
                              ''
                            )}
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          />
          {validations.people}
        </Tile>
        {/* RITM1535076 */}
        <ModalDrillPerson {...modalPersonProps} />
        {!this.props.editingDisabled ? (
          <div className="bx--row table-toolbar-custon-content-info-end ">
            <Button
              size="default"
              renderIcon={Save16}
              kind="secondary"
              onClick={this.savePersonnel}
              disabled={this.props.editingDisabled}
              iconDescription=""
            >
              Save
            </Button>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

DrillPersonnel.propTypes = {
  id: PropTypes.string.isRequired,
  PersonnelData: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
};
DrillPersonnel.defaultProps = {
  disabled: true,
};
